import { render, staticRenderFns } from "./RevenueCard.vue?vue&type=template&id=e484720c&scoped=true&"
import script from "./RevenueCard.vue?vue&type=script&lang=js&"
export * from "./RevenueCard.vue?vue&type=script&lang=js&"
import style0 from "./RevenueCard.vue?vue&type=style&index=0&id=e484720c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e484720c",
  null
  
)

export default component.exports